var SpotModel = require("../models/SpotModel");
var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

/**
 * 
 * @param {QueueModel} viewModel
 * @param {() => string} userLanguage
 */
function TicketsWS(viewModel, userLanguage) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.name = 'TicketsWS';			// Convenience name for debugging
  self.tickets = ko.observableArray([]);
  self.userLanguage = userLanguage;


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    var queryString = '?locale=' + self.userLanguage();
    return '/qless/api/v1/employee/queues/' + self.parent.id + '/tickets/outstanding/mine' + queryString;
  }, self, { deferEvaluation: true });


	/**
	 * Locates a SpotModel instance by the session id
	 *
	 * @method getTicketBySessionId
	 * @param {String} sSessionId
	 * @returns {SpotModel | Null}
	 */
  self.getTicketBySessionId = function (sSessionId) {
    return self.tickets().filter(function (spot) {
      return (spot.sessionId === sSessionId);
    })[0];
  };


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData
	 * @returns {LocationsWS}
	 */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);

    if (json) {
      var spots = Array.makeArray(json.queueSpots.spot);
      var spotModels = [];
      spots.forEach(function (spotData) {
        spotModels.push(new SpotModel(spotData));
      });
      self.tickets(spotModels);
    }
    
    return self;
  };


	/**
	 * Returns the object to it's initial state
	 *
	 * @method reset
	 * @returns none
	 */
  self.reset = function () {
    // Remove any queues
    self.tickets.removeAll();
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.reset.call(self);
  };

  return self;
};

TicketsWS.prototype = AbstractWS.prototype;
TicketsWS.prototype.constructor = TicketsWS;

module.exports = TicketsWS
